import Vue from "vue";
import Vuex from "vuex";
import { getLanguageFromURL, updateHTMLLang } from '@/i18n/utils';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 0,
    // AI 聊天相关状态
    aiChatEnabled: false, // AI 聊天是否可用
    aiInterpretCompleted: false, // AI 解读是否完成
    packageNo: "", // 当前报告编号
    openAiChat:false,
    openInterpret:false,

    // 国际化相关状态
    currentLanguage: 'zh-CN', // 当前语言，默认为中文
    supportedLanguages: ['zh-CN', 'en-US'], // 支持的语言列表
    isInitialized: false // 国际化是否已初始化

  },
  mutations: {
    // 设置 AI 解读完成状态
    SetAiChatEnabled(state, payload) {
      // state.aiInterpretCompleted = payload.completed;
      // state.currentPackageNo = payload.packageNo || "";
      // 只有解读完成后才允许使用聊天
      state.aiChatEnabled = payload.aiChatEnabled;
    },
    // 重置 AI 状态（切换报告时使用）
    RESET_AI_STATE(state) {
      state.aiChatEnabled = false;
      state.aiInterpretCompleted = false;
      state.packageNo = "";
    },
    // ai解读完毕
    SetPackageNo(state,payload){
      state.packageNo = payload.packageNo;

    },
    // ai解读音频
    SetOpenAiChat(state,payload){
      state.openAiChat = payload.openAiChat;

    },
    SetOpenInterpret(state,payload){
      state.openInterpret = payload.openInterpret;

    },

    // 国际化相关 mutations
    SET_LANGUAGE(state, language) {
      state.currentLanguage = language;
    },

    SET_INITIALIZED(state, status) {
      state.isInitialized = status;
    },
    
  },
  getters: {
    // 获取 AI 聊天是否可用
    isAIChatEnabled: (state) => state.aiChatEnabled,
    // 获取当前报告编号
    getPackageNo: (state) => state.packageNo,
    // 获取 AI 解读是否完成
    isAIInterpretCompleted: (state) => state.aiInterpretCompleted,
    // 获取ai助手是否打开
    GetOpenAiChat: (state) => state.openAiChat,
    GetOpenInterpret: (state) => state.openInterpret,

    // 国际化相关 getters
    getCurrentLanguage: (state) => state.currentLanguage,
    isEnglish: (state) => state.currentLanguage === 'en-US',
    isChinese: (state) => state.currentLanguage === 'zh-CN',
    isI18nInitialized: (state) => state.isInitialized,
  },
  actions: {
    // 从 URL 初始化语言设置
    async initLanguageFromURL({ commit, state }) {
      try {
        // 从 URL 检测语言参数
        const language = getLanguageFromURL();
        const previousLanguage = state.currentLanguage;
        
        // 更新 Vuex 状态
        commit('SET_LANGUAGE', language);
        
        // 更新 i18n 实例（如果存在）
        if (this._vm && this._vm.$i18n) {
          this._vm.$i18n.locale = language;
        }
        
        // 更新 HTML lang 属性
        updateHTMLLang(language);
        
        // 标记初始化完成
        commit('SET_INITIALIZED', true);
        
        console.log('国际化语言恢复完成:', {
          currentLanguage: language,
          previousLanguage: previousLanguage,
          url: window.location.href,
          isPageRefresh: !state.isInitialized
        });
      } catch (error) {
        console.error('国际化初始化失败:', error);
        
        // 初始化失败时使用默认中文
        commit('SET_LANGUAGE', 'zh-CN');
        updateHTMLLang('zh-CN');
        commit('SET_INITIALIZED', true);
      }
    },

    // 切换语言
    async setLanguage({ commit }, language) {
      try {
        if (!language || !['zh-CN', 'en-US'].includes(language)) {
          throw new Error('不支持的语言: ' + language);
        }
        
        // 更新 Vuex 状态
        commit('SET_LANGUAGE', language);
        
        // 更新 i18n 实例
        if (this._vm && this._vm.$i18n) {
          this._vm.$i18n.locale = language;
        }
        
        // 更新 HTML lang 属性
        updateHTMLLang(language);
        
        console.log('语言切换成功:', language);
      } catch (error) {
        console.error('语言切换失败:', error);
        throw error;
      }
    }
  },
});
